
    export default {
        layout: 'blank',
    };
